import type { Country } from 'constants/country'
import type { InvoicingAddressPayload } from 'dataQueries/invoicingAddresses.query'

import type { InvoicingAddressFields } from './InvoicingAddressForm.context'

/**
 * The request body for creating or updating an invoicing address. An empty VAT number is left out:
 * the API accepts the field only with 1–50 characters and refuses an empty string with a 400.
 */
export const toInvoicingAddressPayload = (values: InvoicingAddressFields): InvoicingAddressPayload => ({
  addressName: values.addressName,
  companyOrIndividualName: values.companyOrIndividualName,
  streetAndNumber: values.streetAndNumber,
  apartmentNumber: values.apartmentNumber,
  city: values.city,
  region: values.region,
  country: values.country as Country,
  postalCode: values.postalCode,
  vatNumber: values.vatNumber?.trim() || undefined,
})
